var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99301 0.333008C3.31301 0.333008 0.333008 3.31967 0.333008 6.99967C0.333008 10.6797 3.31301 13.6663 6.99301 13.6663C10.6797 13.6663 13.6663 10.6797 13.6663 6.99967C13.6663 3.31967 10.6797 0.333008 6.99301 0.333008ZM6.99967 12.333C4.05301 12.333 1.66634 9.94634 1.66634 6.99967C1.66634 4.05301 4.05301 1.66634 6.99967 1.66634C9.94634 1.66634 12.333 4.05301 12.333 6.99967C12.333 9.94634 9.94634 12.333 6.99967 12.333ZM6.85301 3.66634H6.81301C6.54634 3.66634 6.33301 3.87967 6.33301 4.14634V7.29301C6.33301 7.52634 6.45301 7.74634 6.65967 7.86634L9.42634 9.52634C9.65301 9.65967 9.94634 9.59301 10.0797 9.36634C10.2197 9.13968 10.1463 8.83967 9.91301 8.70634L7.33301 7.17301V4.14634C7.33301 3.87967 7.11967 3.66634 6.85301 3.66634Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.fbc7342e991df6a378f78ab46897a579.svg";
export { ForwardRef as ReactComponent };